"use strict";

var _context;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formatInTimeZone: true,
  getTimezoneOffset: true,
  toDate: true
};
_Object$defineProperty(exports, "formatInTimeZone", {
  enumerable: true,
  get: function () {
    return _dateFnsTz.formatInTimeZone;
  }
});
_Object$defineProperty(exports, "getTimezoneOffset", {
  enumerable: true,
  get: function () {
    return _dateFnsTz.getTimezoneOffset;
  }
});
_Object$defineProperty(exports, "toDate", {
  enumerable: true,
  get: function () {
    return _dateFnsTz.toDate;
  }
});
var _dateFnsTz = require("date-fns-tz");
var _zonedTimeInterface = require("./zoned-time-interface");
_forEachInstanceProperty(_context = _Object$keys(_zonedTimeInterface)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _zonedTimeInterface[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _zonedTimeInterface[key];
    }
  });
});